import { render, staticRenderFns } from "./LabelCard.vue?vue&type=template&id=347dcb1c&"
import script from "./LabelCard.vue?vue&type=script&lang=ts&"
export * from "./LabelCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports